const APP_TYPE_TARGET = [
  { value: 1, text: '公募' },
  { value: 2, text: '推薦のみ' },
];

export default {
  APP_TYPE_TARGET,
};
